var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!['login', 'register', 'forgot', 'reset'].includes(_vm.$route.name))?_c('div',{staticClass:"dashboard-wrapper"},[_c('Sidebar'),_c('main',{staticClass:"dashboard-main"},[_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"dashboard-content"},[_c('router-view')],1)])])],1):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }